














































import Vue from 'vue';
import { Photos } from '@/types';
import LightboxSlider from '@/components/lightbox-slider/lightboxSlider.vue';
import InfiniteScroller from '@/components/scroller/InfiniteScroller.vue';
import BreadCrumbs from '@/components/bread-crumbs/BreadCrumbs.vue';
import AttachmentsModal from '@/views/messages/components/AttachmentsModal.vue';
import ImageGrid from './components/ImageGrid.vue';
import { getJobBadges, getMyPhotos } from '@/api';
import { getRememberMe, showLoader, hideLoader, sortByDate, checkImageUrl } from '@/util';
import { mapGetters } from 'vuex';
import { ActionType, Loader } from '@/constants';
import store from '@/store';

export default Vue.extend({
  name: 'MyPhotos',
  components: {
    LightboxSlider,
    ImageGrid,
    BreadCrumbs,
    InfiniteScroller,
    AttachmentsModal
  },
  data () {
    return {
      sortDirection: -1,
      selctedPhotoIndex: 0,
      slider: false as boolean,
      paginatedPhotosCount: 25,
      allPhotos: [] as Photos[],
      photos: [] as Photos[],
      showSortDropdown: false,
      isVisibleAttachmentsModal: false,
      isVisibleGalleryModal: false,
      isVisibleAccessAttachment: false,
      jobId: '' as string | null,
      uploadMode: '' as string | null,
      newImageCount: 0,
      onEachScrollPhotosNotLoaded: 0,
      nextImageCount: 25
    };
  },
  async mounted () {
    showLoader();
    const footerHeight = document.getElementsByTagName('footer')[0].offsetHeight;
    const photosMessageHeight = (document.getElementsByClassName('photoMessage')[0] as HTMLElement).offsetHeight;
    await this.fetchPhotos(true);
    window.onscroll = () => {
      if ((window.innerHeight + Math.round(window.scrollY) + footerHeight + photosMessageHeight) >= document.body.offsetHeight) {
        if (this.nextImageCount + this.onEachScrollPhotosNotLoaded < this.allPhotos.length) {
          const nextPhotosCount = this.nextImageCount + this.onEachScrollPhotosNotLoaded;
          const paginatedPhotos = this.allPhotos.slice(nextPhotosCount, nextPhotosCount + this.paginatedPhotosCount);
          this.photos = this.photos.concat(paginatedPhotos);
          this.nextImageCount = nextPhotosCount + this.paginatedPhotosCount;
          this.onEachScrollPhotosNotLoaded = 0;
        }
      }
    };
  },
  computed: {
    ...mapGetters([
      'signedIn',
      'badges',
      'isLoggedInAsAdmin'
    ]),
    sortedPhotos (): Photos[] {
      const photos = sortByDate(this.photos, this.sortDirection);
      if (this.newImageCount) {
        let newImagesCount = this.newImageCount;
        photos.forEach((photo) => {
          if (photo.uploadedByType === 'ADMIN' && newImagesCount) {
            photo.isNew = true;
            newImagesCount -= 1;
          } else {
            photo.isNew = false;
          }
        });
      }
      return photos;
    },
    lightGallerySortedPhotos (): Photos[] {
      const photos = sortByDate(this.allPhotos, this.sortDirection);
      if (this.newImageCount) {
        let newImagesCount = this.newImageCount;
        photos.forEach((photo) => {
          if (photo.uploadedByType === 'ADMIN' && newImagesCount) {
            photo.isNew = true;
            newImagesCount -= 1;
          } else {
            photo.isNew = false;
          }
        });
      }
      return photos;
    }
  },
  methods: {
    async fetchPhotos (initialLoad = false) {
      this.jobId = getRememberMe();
      if (initialLoad) {
        const { jobs } = store.getters;
        const job = jobs.filter((data: any) => data.jobNumber === this.jobId);
        this.jobId && job.length > 0 && await getJobBadges(job[0].divisionId, this.jobId);
      }
      this.jobId && getMyPhotos(this.jobId).then(async (data) => {
        if (data) {
          this.allPhotos = data.photos;
          this.allPhotos = await checkImageUrl(this.allPhotos);
          this.allPhotos = this.lightGallerySortedPhotos;
          this.photos = this.allPhotos.slice(0, this.paginatedPhotosCount);
        }
        if (this.badges.images && !this.isLoggedInAsAdmin) {
          this.newImageCount = this.badges.images;
          this.$store.dispatch(ActionType.CLEAR_BADGE, 'images');
        }
        hideLoader();
      });
    },
    toggleSortDropdown () {
      this.showSortDropdown = !this.showSortDropdown;
    },
    toggleSortOptions () {
      this.sortDirection = this.sortDirection === -1 ? 1 : -1;
    },
    toggleLightbox (index: number) {
      this.selctedPhotoIndex = index;
      this.slider = true;
    },
    async uploadImages () {
      this.isVisibleAttachmentsModal = !this.isVisibleAttachmentsModal;
      if (!this.isVisibleAttachmentsModal) {
        this.newImageCount = 0;
        showLoader();
        await this.fetchPhotos();
        this.$emit('resetAttachmentsData');
      }
    }
  }
});
